"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linearTransformation = linearTransformation;

var _transformImage = require("./transformImage");

var _exceptions = require("../exceptions");

function linearTransformation(imgBuffer, points) {
  console.log({
    imgBuffer: imgBuffer,
    points: points
  });
  validatePoints(points, imgBuffer);
  var sections = points.map(extractSections);
  var lookupTable = (0, _transformImage.createLookupTable)(function (dim) {
    var currentSections = sections[dim];
    var currentSectionIndex = 0;
    return function (value) {
      var _currentSections$curr = currentSections[currentSectionIndex],
          frontier = _currentSections$curr.frontier,
          slope = _currentSections$curr.slope,
          yIntercept = _currentSections$curr.yIntercept;

      if (value > frontier) {
        currentSectionIndex += 1;
      }

      var newValue = Math.round(slope * value + yIntercept);
      var newValueClipped = Math.min(Math.max(newValue, 0), 255);
      return newValueClipped;
    };
  });
  return (0, _transformImage.applyLookupTable)(imgBuffer, lookupTable);
}

function validatePoints(points) {
  if (points.length !== 3) {
    throw new _exceptions.ImageOperationException("LinearTransformationException", "Linear transformation needs 3 sets of points, one for each color dimension");
  }

  points.forEach(function (points, dim) {
    if (points.length < 2) {
      throw new _exceptions.ImageOperationException("LinearTransformationException", "Linear transformation needs at least 2 points for each dimension. Color dimension number ".concat(dim, " has ").concat(points.length));
    }

    for (var i = 0; i < points.length - 1; ++i) {
      var current = points[i];
      var next = points[i + 1];

      if (current.x > next.x) {
        throw new _exceptions.ImageOperationException("LinearTransformationException", "Points must be ordered according to the x coordinate value");
      }

      if (current.x === next.x) {
        throw new _exceptions.ImageOperationException("LinearTransformationException", "Different points should not have the same x coordinate value");
      }
    }

    if (points[0].x > 0) {
      throw new _exceptions.ImageOperationException("LinearTransformationException", "X coordinate value of the first point should be less or equal to 0 for the color dimension number ".concat(dim));
    }

    if (points[points.length - 1].x < 255) {
      throw new _exceptions.ImageOperationException("LinearTransformationException", "X coordinate value of the last point should be greater or equal to 255 for the color dimension number ".concat(dim));
    }
  });
}

function extractSections(points) {
  var sections = [];

  for (var i = 1; i < points.length; ++i) {
    var current = points[i];
    var prev = points[i - 1];
    var slope = (current.y - prev.y) / (current.x - prev.x);
    var yIntercept = current.y - slope * current.x;
    var frontier = current.x;
    sections.push({
      slope: slope,
      yIntercept: yIntercept,
      frontier: frontier
    });
  }

  return sections;
}